import { Alert, AlertTitle } from '@material-ui/lab';
import { Snackbar, Typography, makeStyles } from '@material-ui/core';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_INFO } from './types';
import { hideToast } from './layout.actions';

const useStyles = makeStyles((theme) => (
  {
    alertRoot:{
      width: 400,
    },
    anchorOriginTopCenter: {
      top: 10,
    },
    alertMessage: {
      fontSize: '0.9rem',
      minWidth: 300,
      textAlign: 'center',
    },
    reference: {
      fontSize: '0.6rem',
    },
  }
));

const Toast = (props) => {
  const { shouldShowToast, hideToast: propsHideToast, userMustDismissToast, toastSeverity, toastMessage, errorEventId } = props;
  const classes = useStyles();

  // force user dismiss by default for error
  const showDismiss = userMustDismissToast != null ? userMustDismissToast :
    toastSeverity === TOAST_MESSAGE_SEVERITY_ERROR ? true : false;

  return (
    <div>
      <Snackbar
        classes={{
          anchorOriginTopCenter: classes.anchorOriginTopCenter,
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={shouldShowToast}
        onClose={(event, reason) => {
          if (reason !== 'clickaway')
            propsHideToast();
        }}
        autoHideDuration={showDismiss ? null : 3000}
      >
        <Alert
          classes={{
            message: classes.alertMessage,
          }}
          onClose={showDismiss ? propsHideToast : null}
          severity={toastSeverity}
        >
          <AlertTitle>{toastMessage}</AlertTitle>
          {(toastSeverity === TOAST_MESSAGE_SEVERITY_ERROR && errorEventId) && <Typography className={classes.reference}>Reference: {errorEventId}</Typography> }
        </Alert>
      </Snackbar>
    </div>
  );
};

Toast.propTypes = {
  shouldShowToast: PropTypes.bool.isRequired,
  toastMessage: PropTypes.string.isRequired,
  hideToast: PropTypes.func.isRequired,
  userMustDismissToast: PropTypes.bool,
  toastSeverity: PropTypes.string,
  errorEventId: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { shouldShowToast, toastMessage, userMustDismissToast, toastSeverity } = state.layout;
  return {
    shouldShowToast,
    toastMessage,
    userMustDismissToast,
    toastSeverity: toastSeverity ? toastSeverity : TOAST_MESSAGE_SEVERITY_INFO,
    errorEventId: state.apiError.errorEventId,
  };
};

export default connect(mapStateToProps, { hideToast })(Toast);
